module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/ant-2.ae1b5ef8.png";